export const decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/:dimension/uplift" as const;
